import React, { Component, PropTypes } from 'react';
import partial from 'lodash/partial';
import SignContractModal from 'common/containers/sign_contract';
import { signContractRequest } from 'project/ducks/wrapup';

export default class SignContract extends Component {
  constructor(props) {
    super(props);

    this.state = { signing: false };

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState({ signing: !this.state.signing });
  }

  render() {
    const { signing } = this.state;
    const { wrapup, fetchWrapupsIfNeeded, signingAs } = this.props;

    return (
      <div className="sign-wrapup-contract">
        <button className="btn btn-tertiary" onClick={this.toggleModal}>
          Read and sign the contract
        </button>

        <SignContractModal showing={signing} onClose={this.toggleModal}
          customSignRequest={(signatureData) => signContractRequest(wrapup.award.id, signatureData)}
          contract={wrapup.contract} signingAs={signingAs || "creative"}
          onDone={partial(fetchWrapupsIfNeeded, wrapup.project_id, true)}/>
      </div>
    );
  }
}

SignContract.propTypes = {
  wrapup: PropTypes.object.isRequired,
  fetchWrapupsIfNeeded: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./project/components/wrapup/sign_contract.jsx